<!-- https://8es9hr.axshare.com/#g=1&p=%E9%80%80%E7%A4%BE%E7%94%B3%E8%AB%8B -->
<!-- 退社申請 -->
<template>
    <div class style="display: flex">
        <Step :workflow="workflow" @goForm="goForm"></Step>
        <div class="step-form">
            <ListForm
                api="coopNtDepositOrder"
                labelPosition="top"
                formTitle="退社申請"
                :rules="rules"
                :recordToEdit="recordToEdit"
                :formType="formType"
                v-if="$route.meta.keeplive"
            >
                <el-form slot="upload" v-if="id !== 0">
                    <el-form-item label="退社申請書">
                        <el-button type="success" plain @click="downloadSample">列印退社申請書</el-button>
                        <div class="my-2">
                            <el-button type="primary" plain @click="clickUploadBtn">上傳退社申請書掃描檔</el-button>
                            <span
                                style="
									margin-left: 5px;
									font-weight: bold;
									font-size: 16px;
								"
                                v-if="recordToEdit.exitApplyDocUploadTime"
                            >
                                上傳時間 :
                                {{
                                recordToEdit.exitApplyDocUploadTime
                                | trasferDate
                                }}
                            </span>
                            <div v-if="file">{{ file.name }}</div>
                        </div>
                        <el-button type="info" plain @click="download">下載申請書</el-button>
                    </el-form-item>
                </el-form>
                <el-form-item
                    label="擔任保證人情形"
                    slot="memberIouGuarantor"
                    v-if="memberIouGuarantor.length > 0"
                >
                    <table class="table table-bordered mb-0 mt10">
                        <thead class="grey lighten-4">
                            <tr>
                                <th>借據號碼</th>
                                <th>狀態</th>
                                <th>貸款結餘</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in memberIouGuarantor" :key="index">
                                <td>{{ row.iouNumber }}</td>
                                <td>
                                    {{
                                    row.iouStatus !== undefined
                                    ? iouStatus[row.iouStatus]
                                    : iouStatus[0]
                                    }}
                                </td>
                                <td>{{ $addcomma(row.noPayAmount) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </el-form-item>
                <div class="dialog-footer" slot="footer">
                    <el-button type="primary" @click="append" v-if="recordToEdit.isSubmit !== 1">暫存</el-button>
                    <el-button
                        type="primary"
                        plain
                        v-if="id !== 0 && recordToEdit.isSubmit == 0"
                        @click="submit"
                    >送出申請</el-button>
                    <el-button plain @click="back">返回</el-button>
                </div>
            </ListForm>
            <router-view
                :enumData="enumData"
                :reviewInfo="reviewInfo"
                :upperRecordToEdit="recordToEdit"
                v-show="!$route.meta.keeplive"
            ></router-view>
        </div>
        <input style="display: none" type="file" id="uploadFile" @change="uploadFile" accept=".pdf" />
    </div>
</template>

<script>
import Step from "@/components/Step.vue";
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
export default {
    components: { Step, ListForm },
    name: "member_drop_out_edit",
    data() {
        return {
            file: null,
            id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
            rules: {},
            nowTime: "",
            firstGo:
                this.$route.query.firstGo != null
                    ? this.$route.query.firstGo
                    : true,
            mingoNowTime: "",
            members: [],
            memberIouGuarantor: [],
            memberStockAmount: 0,
            iouBalance: 0,
            chooseMember: "",
            recordToEdit: { memberId: 0 },
            enumData: {},
            workflow: [
                {
                    label: "退社申請",
                    status: 1,
                    type: 1
                },
                {
                    label: "主任審查",
                    status: 0,
                    type: 1
                },
                {
                    label: "經理審查",
                    status: 0,
                    type: 1
                },
                {
                    label: "理事會審查",
                    status: 0,
                    type: 1
                },
                {
                    label: "互助基金退保作業",
                    status: 0,
                    type: 1
                },
                {
                    label: "貸款結清作業",
                    status: 0,
                    type: 1
                },
                {
                    label: "股金備轉金結清作業",
                    status: 0,
                    type: 1
                }
            ],
            formType: [
                {
                    label: "申請日期",
                    key: "applyDate",
                    type: "date"
                },
                {
                    label: "申請人",
                    key: "memberId",
                    returnKey: "id",
                    type: "chooseMember",
                    filter: {
                        isFormal: 1,
                        isExit: 0
                    }
                },
                {
                    label: "退社原因",
                    key: "exitReasonId",
                    type: "select",
                    options: []
                },
                {
                    label: "是否申請LPLS 理賠 ( 死亡/完全失能)",
                    key: "isLplsClaim",
                    type: "radio"
                },
                {
                    label: "股金結餘",
                    key: "memberStockAmount",
                    type: "input",
                    disabled: true
                },
                {
                    label: "貸款結餘",
                    key: "iouBalance",
                    type: "input",
                    disabled: true
                },
                {
                    slot: "memberIouGuarantor",
                    type: "slot"
                }

                // {
                //     slot: "upload",
                //     type: "slot"
                // }
            ],
            formList: [
                { label: "退社申請", name: "member_drop_out_edit" },
                { label: "主任審查", name: "member_drop_out_director_review" },
                { label: "經理審查", name: "member_drop_out_manager_review" },
                { label: "理事會審查", name: "member_drop_out_council_review" },
                { label: "貸款結清作業", name: "member_drop_out_settle_loan" },
                {
                    label: "互助基金退保作業",
                    name: "member_drop_out_culroc_suspension"
                },
                {
                    label: "LPLS 理賠申請/給付",
                    name: "member_drop_out_lpls_claim"
                },
                {
                    label: "股金備轉金結清作業",
                    name: "member_drop_out_settle_stock"
                },
                {
                    label: "上傳退社申請書掃描檔",
                    name: "member_drop_out_upload_file"
                }
            ],
            reviewInfo: {}
        };
    },
    created() {
        this.getData();
        // this.getWorlflow();
        this.getnowTime();
        this.getMemberInfo(this.recordToEdit.memberId);
    },
    filters: {
        trasferDate(date) {
            let Y = date.substring(0, 4) - 1911;
            let M = date.substring(5, 7);
            let D = date.substring(8, 10);
            let A = `${Y}-${M}-${D}`;
            return A;
        }
    },
    watch: {
        $route() {
            this.getData();
        },
        "recordToEdit.memberId"(key) {
            this.getMemberInfo(key);
        }
    },
    methods: {
        getData() {
            let url = API.memberExitApply + `?id=${this.id}`;
            let thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.workflow = json.resultData.workflow;
                this.enumData = json.resultData.enumData;

                if (this.firstGo == true) {
                    this.workflow.some(item => {
                        if (item.status == 1) {
                            this.formList.forEach(forms => {
                                if (item.label == forms.label) {
                                    if (item.reviewInfo) {
                                        this.reviewInfo = item;
                                    }
                                    this.go(forms);
                                    this.firstGo = false;
                                }
                            });
                        }
                    });
                }
                this.formType[2].options = json.resultData.enumData.exitReason.map(
                    item => {
                        return {
                            label: item.reason,
                            value: item.id
                        };
                    }
                );
            };
            this.mAxiosGet(url, thenCB);
        },
        getMemberInfo(memberId) {
            let url =
                API.memberExitApply +
                `?action=getMemberInCoopInfo&id=${memberId}`;
            let thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.memberIouGuarantor =
                    json.resultData.data.memberIouGuarantor;
                this.iouStatus = json.resultData.enumData.loanIouStatus;
                this.memberStockAmount = json.resultData.data.memberStockAmount;
                this.iouBalance = json.resultData.data.iouBalance;
            };
            this.mAxiosGet(url, thenCB);
        },
        getnowTime() {
            let date = new Date();
            let Y = date.getFullYear() - 1911;
            let M = date.getMonth() + 1;
            let D = date.getDate();
            let A = `${Y}-${M < 10 ? "0" + M : M}-${D}`;
            //正常日期，傳送用
            let MY = date.getFullYear();
            let MM = date.getMonth() + 1;
            let MD = date.getDate();
            let MA = `${MY}-${MM}-${MD}`;
            this.nowTime = A;
            this.mingoNowTime = MA;
        },
        append() {
            const form = new FormData();
            let applyDate =
                parseInt(
                    $(`.applyDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.applyDate`)
                    .val()
                    .slice(3);

            let url = API.memberExitApply;
            if (this.id == 0) {
                url += `?action=append`;
            } else {
                url += `?action=update`;
                form.append("id", this.id);
            }
            form.append("applyDate", applyDate || "");
            form.append("memberId", this.recordToEdit.memberId || "");
            form.append("exitReasonId", this.recordToEdit.exitReasonId || "");
            form.append("isLplsClaim", this.recordToEdit.isLplsClaim || 0);
            form.append("uploadDate", this.mingoNowTime || "");
            // form.append("file", this.file || "");
            let thenCB = json => {
                if (this.id == 0) {
                    this.id = json.resultData.id;
                    this.$router.push({
                        name: "member_drop_out_edit",
                        params: {
                            id: json.resultData.id
                        }
                    });
                }
                this.$message.closeAll();
                this.$message({
                    type: "success",
                    message: "儲存成功",
                    duration: 5000
                });
            };
            this.mAxiosPost(url, form, thenCB);
        },
        submit() {
            const form = new FormData();
            let url = API.memberExitApply + `?action=submit`;
            form.append("id", this.id);
            let thenCB = json => {
                this.$message.closeAll();
                this.$message({
                    type: "success",
                    message: "儲存成功",
                    duration: 5000
                });
                this.getData();
                //C級社例外處理 根據workflow判斷
                if (this.workflow[1].label == "理事會審查") {
                    this.go(this.formList[3], this.id);
                } else {
                    this.go(this.formList[1], this.id);
                }
            };
            this.mAxiosPost(url, form, thenCB);
        },
        go(forms, id) {
            this.$router.push({
                name: forms.name,
                params: {
                    id: this.id
                }
            });
        },
        clickUploadBtn() {
            let a = document.getElementById("uploadFile");
            a.click();
        },
        uploadFile(event) {
            if (event.target.files && event.target.files[0]) {
                this.file = event.target.files[0];
                this.fileSend();
            }
        },
        fileSend() {
            let url = API.memberExitApply + `?action=uploadMemberExitApply`;
            const form = new FormData();
            form.append("file", this.file);
            form.append("id", this.id);
            let thenCB = json => {
                this.$message.closeAll();
                this.$message({
                    type: "success",
                    message: "檔案已上傳",
                    duration: 5000
                });
            };
            this.mAxiosPost(url, form, thenCB);
        },
        download() {
            let url =
                API.memberExitApply +
                `?action=downloadMemberExitApply&id=${this.id}`;

            this.mDownloadFile(url, true, "申請書.pdf");
        },
        downloadSample() {
            let url =
                API.memberExitApply +
                `?action=downloadMemberExitApplyDemo&id=${this.id}`;

            this.mDownloadFile(url);
        },
        goPage() {
            this.workflow.find(key => {
                if (key.status == 1) {
                    this.$router.push({
                        name: "member_drop_out_director_review",
                        id: this.id
                    });
                }
            });
        },
        goForm(item, index) {
            this.formList.forEach(key => {
                if (key.label == item.label) {
                    this.$router.push({
                        name: `${key.name}`,
                        params: {
                            id: this.id
                        }
                    });
                }
                this.reviewInfo = item;
            });
        },
        back() {
            this.$router.push({ name: "member_drop_out" });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
